import axios from 'axios';
import { environment } from '@/environments/environment';
import { apiHandle, buildFormData } from './apiHandle';
import './interceptors/jwt';
import './interceptors/error';
import './interceptors/client_id';

axios.defaults.baseURL = environment.api;

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

export default {
  /**
   * Fetches data from given url
   */
  get: <T>(url: string, params?: any) => {
    return apiHandle<T>(axios.get(url, { params }));
  },

  getFile: <T>(url: string, params?: any) => {
    return apiHandle<T>(
      axios.get(url, {
        responseType: 'blob',
        params,
      }),
    );
  },

  /**
   * post given data to url
   */
  post: <T>(url: string, data?: any, params?: any) => {
    return apiHandle<T>(axios.post(url, data, { params }));
  },

  /**
   * Updates data
   */
  update: <T>(url: string, data?: any, params?: any) => {
    return apiHandle<T>(axios.put(url, data, { params }));
  },

  /**
   * patch data
   */
  patch: <T>(url: string, data?: any, params?: any) => {
    return apiHandle<T>(axios.patch(url, data, { params }));
  },

  /**
   * Delete
   */
  delete: <T>(url: string, config?: any) => {
    return apiHandle<T>(axios.delete(url, { ...config }));
  },

  /*
   file upload update method
   */
  updateWithFile: <T>(url: string, data: any) => {
    const formData = new FormData();
  
    buildFormData(formData, data);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return apiHandle<T>(axios.put(url, formData, config));
  },

  /*
   file upload post method
   */
  createWithFile: <T>(url: string, data: any) => {
    const formData = new FormData();

    buildFormData(formData, data);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return apiHandle<T>(axios.post(url, formData, config));
  },
};
